import { useWindowSize } from 'react-use';
import Link from 'next/link';

import { isValentinePeriod } from '@/utils/isValentinePeriod';
// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Components
import Icon from '@/components/base/Icon';
import Iconosquare from '@/components/icons/Iconosquare';
import { IconosquareValentine } from '@/components/icons/IconosquareValentine';
import { SideBar } from '@/components/layouts/LayoutPlatform/components/Menu/MenuMobile/Sidebar';

export function MenuMobile() {
    const { isOpen, toggle } = useToggle();
    const { width } = useWindowSize();

    if (isOpen && width > 639) {
        toggle();
    }

    return (
        <div className="mr-3 flex items-center gap-3 sm:hidden">
            <button
                onClick={toggle}
                data-testid="button-toggle-social-inbox-mobile-menu"
                className="flex items-center text-icoGray-500 dark:text-icoDarkMode-wolf">
                <Icon icon="menu-burger" />
            </button>
            {isValentinePeriod() ? (
                <IconosquareValentine />
            ) : (
                <Link href="/" className="inline-block leading-none" data-testid="link-home-page">
                    <Iconosquare size={24} className="text-icoBlue" />
                </Link>
            )}
            <SideBar isMenuOpen={isOpen} toggleMenu={toggle} />
        </div>
    );
}
